<template>
  <div class="Home">
    <Navbar title="Yajobici" />
    <div class="container-fluid p-0">
      <div class="section_1 mt-5 mb-1" style="margin-top: 100px !important"></div>
      
      <br /><br /><br />
      <h3 class="text-center mt-5 responsive-title " >
          Trouvez le prestataire qui vous convient <br>
          parmi plusieurs postes ouverts
      </h3>
      

      <!-- Search Start  -->
      <div
        class="container-fluid mb-2 wow fadeIn"
        data-wow-delay="0.1s"
        style="padding: 5px"
      >
        <div class="container">

            <div class="hero-content">
              <div class="search-box">

                <div class="search-group">
                  <i class="fas fa-search"></i>
                  <select
                    @change="onCategoryChange($event)"
                    class="form-select border-1"
                    required
                  >
                    <option value="" selected disabled>
                      --- Domaine d'activité ---
                    </option>
                    <option
                      v-for="index in categories"
                      :key="index.id"
                      :value="index.id"
                    >
                      {{ index.libelle }}
                    </option>
                  </select>
                </div>

                <div class="search-group">
                  <select
                    @change="onSubCategoryChange($event)"
                    class="form-select border-1"
                    placeholder=""
                    required
                  >
                    <optgroup :label="selectedCatName">
                      <option value="" selected disabled>--- Metier ---</option>
                      <option
                        v-for="subcat in subcategories"
                        :key="subcat.id"
                        :value="subcat.id"
                      >
                        {{ subcat.libelle }}
                      </option>
                    </optgroup>
                  </select>
                </div>
                    <button class="btn btn-primary search-btn"  @click.prevent="searchData">Rechercher</button>
              </div>
            </div>

          <center
            v-if="!currentUser"
            style="text-align: center; font-size: 15px"
          >
            <small
              >Vous êtes un recruteur ? Vous proposez un service ? Êtes-vous à
              la recherche d'une formation ?
              <router-link to="/creation-de-compte" style="color: #f7a51b"
                >Inscrivez-vous</router-link
              >
              .
            </small>
          </center>

          <br />
         
          
        </div>
      </div>
      <br /><br />
      <!-- Search End -->

    </div>

    <!-- Category (Start) -->
    <div class="container-fluid service overflow-hidden py-5">
      <div class="container py-5">

        <div class="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <div class="sub-style">
              <h5 class="sub-title text-primary px-3">
                Explorez ce que nous faisons de mieux
              </h5>
            </div>
            <h6 class="display-6 mb-4">
              Nos domaines d'activités
            </h6>
            <p class="mb-0">
            Du bien-être à la beauté, en passant par la formation et l’événementiel, 
            explorez nos différents domaines d’activités conçus pour vous offrir le meilleur service.</p>
        </div>

        <div v-if="loading" class="container text-center">
            <span style="color: #F7A51B !important">
                Affichage en cours ...
            </span>
        </div>

        <div v-else class="px-3">
            <div v-if="categories.length == 0" class="text-center">
                <span class="text-danger">Désolé, il n'y a pas de domaine disponible :)</span>
            </div>
            <div v-else class="row g-4">
                <div v-for="index in categories" :key="index.id" class="col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                    <CategoryCard 
                        :catTitle="index.libelle" 
                        :catDescription="index.description" 
                        :catOfferNbr="index.id" 
                        :catImage="index.photo"
                        :elId="index.id"
                    />
                </div>
            </div>

            <!-- <div class="d-flex justify-content-center mt-4" v-if="totalPages > 1">
                <nav>
                    <ul class="pagination">

                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <button class="page-link" @click="changePage(currentPage - 1)">
                        Précédent
                        </button>
                    </li>

                    <li 
                        v-for="page in totalPages" 
                        :key="page"
                        class="page-item"
                        :class="{ active: currentPage === page }"
                    >
                        <button class="page-link" @click="changePage(page)">
                        {{ page }}
                        </button>
                    </li>

                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <button class="page-link" @click="changePage(currentPage + 1)">
                        Suivant
                        </button>
                    </li>

                    </ul>
                </nav>
            </div> -->

        </div>

    </div>
    </div>
    <!-- Category (End) -->

    <!-- Counter Facts (Start) -->
    <div class="container-fluid counter-facts py-5">
        <div class="container text-center py-5">
          <b style="font-size: 35px !important;">Vivez la meilleure expérience <span style="color: #61C7F2">YAJOBICI</span> sur mobile !</b> <br>
        </div>
    </div>
    <!-- Counter Facts (end) -->

    <!-- publicité (start) -->
    <div class="lapub wow fadeInUp" data-wow-delay="0.1s" style="background-color:  #ffffff !important;" >

      <section v-if="compsettings" class="mb-4">
        <div class="container px-5">
          <div class="row">
            <div class="col-md-5 mb-4 text-center">
              <img
                class="img-fluid mt-5wow fadeInUp" data-wow-delay="0.1s"
                src="../../assets/img/publa.png"
                alt="image"
              />
            </div>
            <div class="col-md-7 text-center">
              <p class="text-light responsive-title2" style="color: #F7A51B !important; margin-top: 120px !important;">
                Téléchargez notre application et accédez à tous les services en quelques clics, où que vous soyez.
              </p>

              <div class="flex social-btns">
                <a :href="compsettings.appstore_url" class="app-btn blu flex p-1" target="_blank">
                  <i class="fab fa-apple"></i>
                  <p>
                    <br> 
                    <span class="big-txt">App Store</span>
                  </p>
                </a>

                <a :href="compsettings.playstore_url" class="app-btn blu flex p-1" target="_blank">
                  <i class="fab fa-google-play"></i>
                  <p>
                    <br>
                    <span class="big-txt">Google Play</span>
                  </p>
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>
       <div v-else>
          <p style="color: transparent !important;">Chargement des informations...</p>
       </div>

     </div>
    <!-- publicité (end) -->


    <!-- Footer (Start) -->
    <Footer />
    <!-- Footer (End) -->
  </div>
</template>

<script>

import Navbar from "../../components/Navbar.vue";
import Footer from "../../components/Footer.vue";
import CategoryCard from "../../components/CategoryCard.vue";
import router from "@/router";

export default {
  name: "Home",
  components: {
    Navbar,
    Footer,
    CategoryCard,
  },

  computed: {
    compsettings() {
      return this.$store.state.staticdata.compsettings;
    },
    loadingCompsettings() {
      return this.$store.state.staticdata.loadingCompsettings;
    },
    errorCompsettings() {
      return this.$store.state.staticdata.errorCompsettings;
    },

    // paginatedCategories() {
    //   const start = (this.currentPage - 1) * this.itemsPerPage;
    //   const end = start + this.itemsPerPage;
    //   return this.categories.slice(start, end);
    // },

    // totalPages() {
    //   return Math.ceil(this.categories.length / this.itemsPerPage);
    // }
  },

  created() {
    this.$store.dispatch("staticdata/fetchCompSetting");
  },

  data() {
    return {
      loading: false,
      categories: [],
      currentUser: null,
      selectedCatName: null,
      selectedSubCatName: null,
      subcategories: [],
      searchResult: null,
      searchIsLoading: false,
      subCatId: "",
      currentPage: 1,
      itemsPerPage: 9
    };
  },

  mounted() {
    this.categoriesList();
  },

  methods: {

    handleImageError(event) {
      event.target.src = require('../../assets/img/avatar.png');
    },

    async categoriesList() {
      await this.$store.dispatch("staticdata/fetchCategorie").then(
        (response) => {
          this.categories = response.data;
        },
        (error) => {
          console.log("error--- ", error);
        }
      );
    },

    async onCategoryChange(event) {
      if (event.target.value != "") {
        this.searchResult = [];
        this.selectedCatName =
          event.target.options[event.target.options.selectedIndex].text;
        await this.$store
          .dispatch("staticdata/fetchSubCategorie", event.target.value)
          .then(
            (response) => {
              this.subcategories = response.data;
            },
            (error) => {
              console.log("subcategories error--- ", error);
            }
          );
      }
    },

    async onSubCategoryChange(event) {
      if (event.target.value != "") {
        this.subCatId = event.target.value;
        this.searchResult = [];
        this.selectedSubCatName =
          event.target.options[event.target.options.selectedIndex].text;
      }
    },

    async searchData() {
      if (this.subCatId != "") {
        router.push({
          name: "SearchResult",
          query: {
            subCatId: this.subCatId,
            catName: this.selectedCatName,
            subCatName: this.selectedSubCatName
          }
        });
      }
    },

  },
};

</script>


<style scoped>

.pagination .page-link {
  color: #61C7F2;
  border-radius: 8px;
  margin: 0 4px;
}

.pagination .page-item.active .page-link {
  background-color: #61C7F2;
  border-color: #61C7F2;
  color: #fff;
}

.pagination .page-link:hover {
  background-color: #F7A51B;
  color: #fff;
}



.hero-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
}


/* Hero Section */
.hero {
    background: linear-gradient(rgba(37, 99, 235, 0.9), rgba(29, 78, 216, 0.85)), url('../../assets/img/banner.png') center center/cover;
    color: white;
    padding: 80px 0;
    text-align: center;
}

.hero-content {
    width: 100% !important;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
}

.search-box {
    width: 90% !important;
    background-color: white;
    border-radius: 8px !important;
    padding: 25px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;
}

.search-group {
    flex: 1 1 200px;
    position: relative;
}

.search-group i {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #dddddd;
}

.search-group select {
    width: 100%;
    padding: 12px 12px 12px 35px;
    border: 1px solid #dddddd;
    border-radius: 8px !important;
    font-size: 1rem;
}

.search-btn {
    padding: 12px 24px;
    flex: 0 0 auto;
}

a {
  text-decoration: none !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-btn {
  width: 45%;
  max-width: 160px;
  color: #fff;
  margin: 20px 10px;
  text-align: left;
  border-radius: 5px;
  text-decoration: none;
  font-size: 10px;
  text-transform: uppercase;
}
.app-btn.blu {
  background-color: #101010;
  transition: background-color 0.25s linear;
}
.app-btn.blu:hover {
  color: #fff;
  border-color: #fff !important;
  background-color: #61c7f2;
}
.app-btn i {
  width: 20%;
  text-align: center;
  font-size: 25px;
  margin-right: 7px;
}
.app-btn .big-txt {
  font-size: 17px;
  text-transform: capitalize;
}


.responsive-title {
  line-height: 1.3;
  font-size: 20px; /* Mobile */
}

/* Tablette */
@media (min-width: 768px) {
  .responsive-title {
    font-size: 28px;
  }
}

/* PC normal */
@media (min-width: 992px) {
  .responsive-title {
    font-size: 40px;
  }
}

.responsive-title2 {
  line-height: 1.3;
  font-size: 15px; /* Mobile */
}

/* Tablette */
@media (min-width: 768px) {
  .responsive-title2 {
    font-size: 20px;
  }
}

/* PC normal */
@media (min-width: 992px) {
  .responsive-title2 {
    font-size: 35px;
  }
}
</style>